import defaultTranslations from './default'
const translations = {
  default: defaultTranslations,
}
export default translations
